import React from "react";

// ui importing
import HomeUI from "../../../ui/homeUI/_index";

const ProposeSend = () => {
  return (
    <>
      <HomeUI />
    </>
  );
};

export default ProposeSend;
